import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import {
  ENKASH_TENANT_VALUE,
  tenantSetter,
} from "@app-common/http/interceptors/tenantType";
import {
  RequestState,
  RequestStateEnum,
} from "@app-module/shared/RequestState";
import { DashboardCardsService } from "@app-service/dashboard-cards.service";
import { ToasterService, ToasterType } from "@app-service/toaster.service";
import { UserService } from "@app-service/user.service";
import { Subscription } from "rxjs";
// import { MealCardInfoComponent } from "../meal-card-info/meal-card-info.component";
import { ConfirmationModalService } from "@app/admin/confirmation-modal.service";
import { PopupLayoutComponent } from "@app/admin/confirmation-popup/popup-layout/popup-layout.component";
import { ErupiInfoComponent } from "../erupi-info/erupi-info.component";
// import { MealCardInfoComponent } from "@app/home/meal-card-info/meal-card-info.component";
// import { PettyCashInfoComponent } from "../erupi-info/erupi-info.component";

@Component({
    selector: "app-create-prepaid-account-popup",
    templateUrl: "./create-erupi-account-popup.component.html",
    styleUrls: ["./create-erupi-account-popup.component.scss"],
    standalone: false
})
export class CreateErupiPopupComponent implements OnInit {
  private subscriptions: Subscription = new Subscription();
  submitRequestState: RequestState;
  @ViewChild("modal") modal: PopupLayoutComponent;

  constructor(
    public userService: UserService,
    private cardsDashboardService: DashboardCardsService,
    private toasterService: ToasterService,
    private confirmationModal: ConfirmationModalService
  ) {
    this.submitRequestState = RequestState.init();
  }

  form: FormGroup = new FormGroup({
    accountTitle: new FormControl(null, [Validators.required]),
  });
  ngOnInit(): void {}

  formActionRequestState(): RequestStateEnum {
    return this.submitRequestState.state;
  }

  onSave(): void {
    tenantSetter(ENKASH_TENANT_VALUE);

    let payload = {
      companyId: this.userService.currentUser.companyId,
      companyName: this.userService.currentUser.companyName
        ? this.userService.currentUser.companyName
        : this.form.get("accountTitle").value,
      userId: this.userService.currentUser.userId,
      email: this.userService.currentUser.email,
      mobile: this.userService.currentUser.mobile,
      accountTitle: this.form.get("accountTitle").value,
      accountType: "E_RUPI_VOUCHER",
      kitType: "RUPAY", //needs to change
    };

    if (this.submitRequestState.isPending()) {
      return;
    }

    this.submitRequestState.pending();
    this.subscriptions.add(
      this.cardsDashboardService.createCardAccount(payload).subscribe(
        (res) => {
          this.submitRequestState.completed();
          // localStorage.setItem("selectedAccount", JSON.stringify(res));
          this.modal.close(payload);
          this.confirmationModal
            .showInformationalModal(ErupiInfoComponent, {
              centered: true,
              scrollable: true,
              size: "xl",
            })
            .then((result) => {})
            .catch((err) => {});
        },
        (err) => {
          this.submitRequestState.rejected();
          this.toasterService.showToaster(
            err["error"]["payload"]
              ? err["error"]["payload"]
              : "Something went wrong",
            ToasterType.ERROR
          );
        }
      )
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
